import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { oauthRevokeToken } from '../../../actions/api-actions';
import { gotoLoginPage } from '../../../utilities/utility';
import './cp-info.css';
import logger from '../../../services/logger';
import { Dropdown } from '../../../components/cp-dropdown/cp-dropdown';

function AuthInfo() {
  const dispatch = useDispatch();

  const SignOut = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(oauthRevokeToken());
      logger.debug(response);
      gotoLoginPage();
    } catch (error) {
      logger.error('LOGOUT ERROR ', error);
      // Handle any errors that occur during the logout process
      // TODO
    }
    //
  };

  return (
    <div className="kiosk_mode_css">
      <Dropdown
        action={['click']}
        className="txn-tr-dropdown"
        onClick={(event) => event.stopPropagation()}
        content={
          <div className="bb-2 p-15 f-w-500 d-flex cursor_pointer" onClick={(e) => SignOut(e)}>
            Logout
          </div>
        }
      >
        <FontAwesomeIcon className="notifications-more-icon f-30" icon={faEllipsisVertical} />
      </Dropdown>
    </div>
  );
}

export default AuthInfo;
